import React from 'react';

import { colors } from '../../';

interface HeartProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const Heart = ({ color, width, height, className }: HeartProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || '23'}
    height={height || '21'}
    viewBox="0 0 23 21"
    className={className}
  >
    <path
      fill={color || colors.gray60}
      fillRule="evenodd"
      d="M20.947 12.248l-7.686 7.686a2.518 2.518 0 0 1-3.56 0l-7.687-7.686c-2.731-2.731-2.692-7.22.164-9.822a6.742 6.742 0 0 1 9.298.216.006.006 0 0 0 .01 0 6.742 6.742 0 0 1 9.298-.216c2.856 2.601 2.895 7.09.163 9.822"
    />
  </svg>
);

export default Heart;
